import React from 'react';

import {colors} from 'styles/shared';

function Icon(props) {
  let color = props.color || colors.blue_main;

  return (
    <svg width="23" height="22" fill="none" viewBox="0 0 23 22">
      <path
        fill={color}
        fillRule="evenodd"
        d="M18.174 15.304H22a.957.957 0 01.956.957v.956A4.783 4.783 0 0118.174 22H4.783A4.783 4.783 0 010 17.217V2.87A2.87 2.87 0 012.87 0h12.434a2.87 2.87 0 012.87 2.87v12.434zM1.913 2.87v14.347a2.87 2.87 0 005.74 0v-.956a.957.957 0 01.956-.957h7.652V2.87a.957.957 0 00-.957-.957H2.87a.957.957 0 00-.957.957zm7.652 14.347a4.735 4.735 0 01-.956 2.87h9.565a2.87 2.87 0 002.87-2.87H9.565zM13.391 5.74H4.783a.957.957 0 010-1.913h8.608a.957.957 0 110 1.913zM4.783 9.565h8.608a.957.957 0 000-1.913H4.783a.957.957 0 000 1.913zm9.285 3.546a.957.957 0 01-.677.28H4.783a.956.956 0 010-1.913h8.608a.956.956 0 01.677 1.633z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export default Icon;
